import Vue from 'vue'
import * as types from '@/store/mutation-types'
import {hasUndefinedKey} from '@/utils/objectUtils';


export default {
    [types.SET_ACTIVE_INDICATOR_ID]: (state, indicatorId) => {
        Vue.set(state, 'activeIndicatorId', indicatorId);
    },

    [types.SET_ACTIVE_INDICATOR_DATA]: (state, indicatorData) => {
        Vue.set(
            state,
            'activeIndicatorData',
            indicatorData
        );
    },
    [types.REMOVE_ACTIVE_INDICATOR_OBSERVATION_GROUP_DATA]: (state, payload) => {
        let observationGroupId = payload.observationGroupId;

        Vue.delete(state.activeIndicatorData.observationGroups, observationGroupId)
    },

    [types.SET_ACTIVE_INDICATOR_OBSERVATION_GROUP_DATA]: (state, payload) => {
        let observationGroupId = payload.observationGroupId;
        let observationGroupData = payload.observationGroupData;

        Vue.set(
            state.activeIndicatorData.observationGroups,
            observationGroupId,
            observationGroupData
        );
    },

    [types.REMOVE_ACTIVE_INDICATOR_OBSERVATION_DATA]: (state, payload) => {
        let observationGroupId = payload.observationGroupId;
        let observationId = payload.observationId;

        Vue.delete(state.activeIndicatorData.observationGroups[observationGroupId].observations, observationId)
    },

    [types.SET_ACTIVE_INDICATOR_OBSERVATION_DATA]: (state, payload) => {
        let observationGroupId = payload.observationGroupId;
        let observationId = payload.observationId;
        let observationData = payload.observationData;

        Vue.set(
            state.activeIndicatorData.observationGroups[observationGroupId].observations,
            observationId,
            observationData
        );
    },
}
